export default {
	state: {
		shops: [
			{
				id: 1,
				scrolll: 'evd',
				// name: 'Фирменная кафе-пекарня «ГРIДНЕВЪ-ХЛЕБЪ» (Евдокимова)',
				street: 'ул. Евдокимова, 102 б',
				tel:'tel:89094299222',
				phone: '+7 909 429 92 22',
				// textCall: 'По этому телефону Вы всегда сможете получить консультацию по ассортименту нашей продукции и ее наличию в торговой точке, сделать предзаказ (на определённые позиции) и уточнить наше точное расположение, а также часы работы',
				photoTitle: 'Фото магазина-пекарни',
				timeWork: 'Работаем с 9:00 до 21:00 (ПН - ВС)',
				picUrl: '/img/shops/1/00.jpg',
				map: '<iframe src="https://www.google.com/maps/d/u/0/embed?mid=1pfPIyfV3HQAdeznhhu1kkhdEecqfJ3hF" width="100%" height="480"></iframe>',
				onPhotoDescr: 'ул. Евдокимова, 102 б'
			},
			{
				id: 2,
				scrolll: 'v',
				// name: 'Фирменная кафе-пекарня «ГРIДНЕВЪ-ХЛЕБЪ» (Ворошиловский)',
				street: 'пр. Ворошиловский, 25',
				tel:'tel:89613170606',
				phone: '+7 961 317 06 06',
				// textCall: 'По этому телефону Вы всегда сможете получить консультацию по ассортименту нашей продукции и ее наличию в торговой точке, сделать предзаказ (на определённые позиции) и уточнить наше точное расположение, а также часы работы',
				photoTitle: 'Фото магазина',
				timeWork: 'Работаем с 8:00 до 20:00 (ПН - ВС)',
				picUrl: '/img/shops/2/000.jpg',
				map: '<iframe src="https://www.google.com/maps/d/u/0/embed?mid=1k7LzmMKofR81jRMuAEQ5ocdHZ664tXpD" width="100%" height="300"></iframe>',
				onPhotoDescr: 'пр. Ворошиловский, 25'
			},
			{
				id: 3,
				scrolll: 'g',
				// name: 'Фирменная кафе-пекарня «ГРIДНЕВЪ-ХЛЕБЪ» (Горького)',
				street: 'ул. Максима Горького, 245/107',
				tel:'tel:89281887854',
				phone: '+7 928 188 78 54',
				// textCall: 'По этому телефону Вы всегда сможете получить консультацию по ассортименту нашей продукции и ее наличию в торговой точке, сделать предзаказ (на определённые позиции) и уточнить наше точное расположение, а также часы работы',
				photoTitle: 'Фото магазина',
				timeWork: 'Работаем с 8:00 до 20:00 (ПН - ВС)',
				picUrl: '/img/shops/3/00.jpg',
				map: '<iframe src="https://www.google.com/maps/d/u/0/embed?mid=1zlq1xcUQ1b4ctNk06yv8OPH762bZIagE" width="100%" height="300"></iframe>',
				onPhotoDescr: 'Максима Горького, 245/107'
			}
		]
	},
	mutations: {},
	actions: {},



	getters: {
		getShops (state) {
			return state.shops
		}
	}

}